<script lang="ts">
  export let selected = false;
  export let mainGradientColor = "#3361FF";
  export let secondGradientColor = "#C447FF";
  export let width = "50";
</script>

<svg
  viewBox="0 0 50 50"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  style={`${selected ? "outline: 3px solid #1E5EFE;" : ""} ${width ? "width: " + width + "px;" : ""}`}
>
  <path
    d="M1.5 25C1.5 12.0213 12.0213 1.5 25 1.5C37.9787 1.5 48.5 12.0213 48.5 25C48.5 37.9787 37.9787 48.5 25 48.5C12.0213 48.5 1.5 37.9787 1.5 25Z"
    fill="url(#paint0_linear_820_1982)"
  />
  <path
    d="M37.0314 39.057L37.0332 39.0573C38.1783 39.2322 38.9471 38.116 38.5385 37.1958C37.9575 35.8861 37.4296 34.1732 37.2189 32.5795C39.4708 30.2844 40.8464 27.3231 40.8464 24.0797C40.8464 16.6053 33.6358 10.7422 25.013 10.7422C16.3902 10.7422 9.17969 16.6053 9.17969 24.0797C9.17969 31.5542 16.3902 37.4173 25.013 37.4173M37.0314 39.057L29.0817 36.4258L37.0314 39.057ZM37.0314 39.057L37.0296 39.0567C33.0839 38.439 31.5231 36.6211 29.2862 36.9259M25.013 37.4173L29.0817 36.4258L25.013 37.4173ZM25.013 37.4173C25.0126 37.4173 25.0122 37.4173 25.0118 37.4173L29.0817 36.4258M25.013 37.4173C26.4534 37.419 27.8882 37.254 29.2862 36.9259L25.013 37.4173Z"
    fill="white"
  />
  <path
    d="M37.0314 39.057L37.0332 39.0573C38.1783 39.2322 38.9471 38.116 38.5385 37.1958C37.9575 35.8861 37.4296 34.1732 37.2189 32.5795C39.4708 30.2844 40.8464 27.3231 40.8464 24.0797C40.8464 16.6053 33.6358 10.7422 25.013 10.7422C16.3902 10.7422 9.17969 16.6053 9.17969 24.0797C9.17969 31.5542 16.3902 37.4173 25.013 37.4173M37.0314 39.057L29.0817 36.4258M37.0314 39.057L37.0296 39.0567C33.0839 38.439 31.5231 36.6211 29.2862 36.9259M25.013 37.4173L29.0817 36.4258M25.013 37.4173C25.0126 37.4173 25.0122 37.4173 25.0118 37.4173L29.0817 36.4258M25.013 37.4173C26.4534 37.419 27.8882 37.254 29.2862 36.9259M29.2862 36.9259C29.1711 36.8737 29.0657 36.8241 28.9697 36.7776M29.2862 36.9259C29.3993 36.8994 28.8571 37.026 28.9697 36.9973"
    stroke="white"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M34.437 31.2344C34.2532 31.4188 34.1124 31.6416 34.0245 31.8868C33.9366 32.1319 33.904 32.3935 33.9288 32.6528C34.0532 33.8527 34.2892 35.0383 34.6335 36.1944C32.1633 35.6225 30.6545 34.9602 29.9692 34.6131C29.5805 34.4162 29.1328 34.3695 28.7119 34.482C27.5052 34.8037 26.2614 34.9657 25.0126 34.9637C17.9364 34.9637 12.6168 29.993 12.6168 24.3387C12.6168 18.6862 17.9364 13.7137 25.0126 13.7137C32.0889 13.7137 37.4084 18.6862 37.4084 24.3387C37.4084 26.9383 36.3159 29.3502 34.437 31.2344ZM35.31 38.1494C35.7296 38.2326 36.1505 38.3088 36.5726 38.3779C36.9268 38.4345 37.1959 38.0662 37.056 37.7369C36.8988 37.366 36.7547 36.9898 36.624 36.6088L36.6187 36.5911C36.1795 35.3161 35.8218 33.8499 35.6907 32.4845C37.8635 30.3064 39.1793 27.4554 39.1793 24.3387C39.1793 17.4927 32.8362 11.9429 25.0126 11.9429C17.189 11.9429 10.8459 17.4927 10.8459 24.3387C10.8459 31.1848 17.189 36.7345 25.0126 36.7345C26.4158 36.7364 27.813 36.5542 29.1688 36.1927C30.0896 36.6584 32.0712 37.5066 35.31 38.1494Z"
    fill="url(#paint1_linear_820_1982)"
  />
  <path
    d="M25.7886 23.1727C25.7886 24.5143 26.9202 25.6022 28.3172 25.6022C29.7143 25.6022 30.846 24.5143 30.846 23.1727C30.846 21.8311 29.7143 20.7417 28.3172 20.7417C26.9202 20.7417 25.7886 21.8296 25.7886 23.1727Z"
    fill="url(#paint2_linear_820_1982)"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M27.6999 22.1073C27.7239 22.19 27.7644 22.267 27.8189 22.3336C27.8734 22.4002 27.9408 22.4552 28.0172 22.4951C28.0934 22.535 28.177 22.559 28.2628 22.5658C28.3486 22.5726 28.4349 22.562 28.5165 22.5347C28.594 22.5116 28.6661 22.4732 28.7284 22.4218C28.7907 22.3703 28.842 22.3069 28.8794 22.2351C28.9166 22.1634 28.9391 22.0849 28.9454 22.0044C28.9517 21.9238 28.9418 21.8428 28.9161 21.7661C28.7994 21.4307 28.5807 21.1245 28.2205 20.9699C28.0582 20.9046 27.8844 20.8727 27.7095 20.8762C27.5345 20.8798 27.3621 20.9185 27.2026 20.9903C26.6383 21.2236 26.1527 21.7851 25.8566 22.4442C25.2325 23.8267 25.2835 25.9106 27.2303 27.8487C27.3491 27.9645 27.5077 28.0305 27.6737 28.0332C27.8396 28.0359 28.0002 27.9752 28.1228 27.8633C28.1826 27.8091 28.2306 27.7434 28.2639 27.67C28.2973 27.5966 28.3153 27.5171 28.3168 27.4365C28.3183 27.3559 28.3033 27.2758 28.2727 27.2013C28.2421 27.1267 28.1965 27.0592 28.1388 27.0029C26.5449 25.4177 26.596 23.8559 27.016 22.9284C27.2376 22.4384 27.5322 22.1788 27.7013 22.1073H27.6999Z"
    fill="url(#paint3_linear_820_1982)"
  />
  <path
    d="M19.4673 23.1727C19.4673 24.5143 20.5989 25.6022 21.996 25.6022C23.3916 25.6022 24.5247 24.5143 24.5247 23.1727C24.5247 21.8311 23.3916 20.7417 21.996 20.7417C20.5989 20.7417 19.4673 21.8296 19.4673 23.1727Z"
    fill="url(#paint4_linear_820_1982)"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M21.3785 22.1073C21.4025 22.19 21.443 22.267 21.4975 22.3336C21.552 22.4002 21.6194 22.4552 21.6957 22.4951C21.772 22.535 21.8556 22.559 21.9414 22.5658C22.0272 22.5726 22.1135 22.562 22.1951 22.5347C22.2726 22.5116 22.3447 22.4732 22.407 22.4218C22.4693 22.3703 22.5207 22.3069 22.558 22.2351C22.5952 22.1634 22.6177 22.0849 22.624 22.0044C22.6304 21.9238 22.6204 21.8428 22.5947 21.7661C22.478 21.4307 22.2593 21.1245 21.8991 20.9699C21.7368 20.9046 21.563 20.8727 21.3881 20.8762C21.2132 20.8798 21.0407 20.9185 20.8812 20.9903C20.3168 21.2236 19.8312 21.7851 19.5337 22.4442C18.9096 23.8267 18.9621 25.9106 20.9074 27.8487C21.0264 27.9649 21.1853 28.0312 21.3515 28.0339C21.5178 28.0366 21.6788 27.9756 21.8014 27.8633C21.8611 27.8091 21.9092 27.7434 21.9426 27.67C21.9759 27.5966 21.9939 27.5171 21.9954 27.4365C21.9969 27.3559 21.9819 27.2759 21.9513 27.2013C21.9207 27.1267 21.8751 27.0592 21.8174 27.0029C20.2235 25.4177 20.2746 23.8559 20.6946 22.9284C20.9162 22.4384 21.2108 22.1788 21.3785 22.1073Z"
    fill="url(#paint5_linear_820_1982)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_820_1982"
      x1="25"
      y1="7.45058e-07"
      x2="3.21413e-07"
      y2="28.0906"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={mainGradientColor} />
      <stop offset="1" stop-color={secondGradientColor} />
    </linearGradient>
    <linearGradient
      id="paint1_linear_820_1982"
      x1="38.1841"
      y1="24.3094"
      x2="1.56737"
      y2="24.4265"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={mainGradientColor} />
      <stop offset="1" stop-color={secondGradientColor} />
    </linearGradient>
    <linearGradient
      id="paint2_linear_820_1982"
      x1="28.3173"
      y1="20.7417"
      x2="28.3173"
      y2="25.6022"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={mainGradientColor} />
      <stop offset="1" stop-color={secondGradientColor} />
    </linearGradient>
    <linearGradient
      id="paint3_linear_820_1982"
      x1="27.2245"
      y1="20.876"
      x2="27.2245"
      y2="28.0333"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={mainGradientColor} />
      <stop offset="1" stop-color={secondGradientColor} />
    </linearGradient>
    <linearGradient
      id="paint4_linear_820_1982"
      x1="21.996"
      y1="20.7417"
      x2="21.996"
      y2="25.6022"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={mainGradientColor} />
      <stop offset="1" stop-color={secondGradientColor} />
    </linearGradient>
    <linearGradient
      id="paint5_linear_820_1982"
      x1="20.9025"
      y1="20.876"
      x2="20.9025"
      y2="28.034"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={mainGradientColor} />
      <stop offset="1" stop-color={secondGradientColor} />
    </linearGradient>
  </defs>
</svg>

<style>
  svg {
    width: 49px;
    border-radius: 48px;
  }
</style>
